import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeManualOperation extends Shape {
    width = 200;
    height = 154;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width / 2 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;
        const skew = width * 0.22;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + 2 * r, y); // 2*r потому что с просто r немного не правильно отображается угол
        canv.ctx.arcTo(x + width, y, x + width - skew, y + height, r);
        canv.ctx.arcTo(x + width - skew, y + height, x + skew, y + height, r);
        canv.ctx.arcTo(x + skew, y + height, x, y, r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" d="m4.58 18.99-.44.13m.44-.13L1.08 6.16C.7 4.83 1.67 3.5 2.99 3.5h18.02c1.32 0 2.28 1.33 1.91 2.66M4.58 18.99A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 1.92-1.51l3.5-12.83m0 0Z"/>
            </svg>
        `;
    }
}
